<section class="container">
  <div class="header">
    <ng-content select="[header]"></ng-content>
    @if (title) {
      <span
        class="title"
        [class.right]="titleRight"
        >{{ title }}</span
      >
    }
    @if (image) {
      <div
        class="header-image"
        [style.background-image]="'url(' + IMAGES_PATH.banners[image].img + '),url(' + IMAGES_PATH.banners[image].bg + ')'"
      ></div>
    }
    @if (closeable && isDesktop) {
      <span
        class="icon-close"
        (click)="close()"
      ></span>
    }
  </div>
  <div class="body">
    <ng-content select="[body]"></ng-content>
  </div>
  <div class="footer">
    <ng-content select="[footer]"></ng-content>
  </div>
</section>
